export interface PosizioneFasi {
  id: number; 
  faseStandard: FasiACollaudo | FasiNonACollaudo;
  idOrdine: number;
  idPosizione: number
  nota: string;  
  dataConvocazione:Date;
  dataStimata: Date;
  dataIspezione: Date;
  progresso: number;
  isLavorato?:boolean;
  hasIspezione?: boolean;
  isIspezioneConfermata?: boolean;
  isIspezioneRifiutata?: boolean;
  deltaGiorno?:number;
}

export enum FaseStandard {

  DOC_CONTRATTUALE = "Documentazione contrattuale", //mandatory
  COLLAUDO_FINALE = "Ispezione finale/Qr Code", //mandatory
  FINAL_DATA_BOOK = "Final data book",//mandatory,
  IDEN_MATERIA_PRIMA = "Identificazione materia prima",
  INS_NASTRI_LAMIERE = "Inserimento nastri/lamiere",
  PRELIEVO_PROVE = "Prelievo prove",
  PROVE_MECCANICHE = "Prove meccaniche",
  CND_CONTROLLLI_NN_DIST = "CND controlli non distruttivi",
  PROVE_ELETTRICHE = "Prove elettriche",
  PROVE_IDRAULICHE_PNEUM = "Proveidrauliche/pneumatiche",
  VISIVO_DIMENSIONALE = "Visivo/dimensionale",
  FUNZIONALE = "Funzionale",
  VERNICIATURA_RIV = "Verniciatura/Rivestimento",
  ATTIVITA = "Attività"

}

export enum FasiACollaudo {
  DOC_CONTRATTUALE = "Documentazione contrattuale", //mandatory
  COLLAUDO_FINALE = "Ispezione finale/Qr Code", //mandatory
  FINAL_DATA_BOOK = "Final data book",//mandatory,
  IDEN_MATERIA_PRIMA = "Identificazione materia prima",
  INS_NASTRI_LAMIERE = "Inserimento nastri/lamiere",
  PRELIEVO_PROVE = "Prelievo prove",
  PROVE_MECCANICHE = "Prove meccaniche",
  CND_CONTROLLLI_NN_DIST = "CND controlli non distruttivi",
  PROVE_ELETTRICHE = "Prove elettriche",
  PROVE_IDRAULICHE_PNEUM = "Proveidrauliche/pneumatiche",
  VISIVO_DIMENSIONALE = "Visivo/dimensionale",
  FUNZIONALE = "Funzionale",
  VERNICIATURA_RIV = "Verniciatura/Rivestimento",
  ATTIVITA = "Attività"
}

export enum FasiNonACollaudo {
  REP_MATERIA_PRIMA="Reperimento materia prima",
  DOCUMENTAZIONE_CONTRATTUALE="Documentazione contrattuale",
  CERTIFICAZIONE_DOC_FINALE="Certificazione/documentazione finale", //mandatory
  IMBALLAGGIO="Imballaggio/QR code",
  TRASPORTO="Trasporto"
}

